define.alias("ember-cli-string-helpers/helpers/classify", "preview-grid/helpers/classify");